var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"enrolling-log-item-wrap"},[_c('div',{staticClass:"log-item-wrap-cont"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.log.title))]),_vm._v(" "),_c('div',{ref:"logContent",staticClass:"content"}),_vm._v(" "),_c('div',{staticClass:"operate-user"},[_vm._v("操作人："+_vm._s(_vm.log.operateUser))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }